import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./index.scss";

import PrivacyModal from "../First/PrivacyModal";
import ServiceModal from "../First/ServiceModal";

interface IProps {}

interface IState {
    showPrivacy: boolean;
    showService: boolean;
}

// 第三屏
class ThirdPage extends BaseComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showService: false,
            showPrivacy: false,
        };
    }

    /**打开用户协议*/
    onOpenService = () => {
        this.setState({
            showService: true,
        });
    };

    /**关闭用户协议*/
    onCloseService = () => {
        this.setState({
            showService: false,
        });
    };

    /**打开隐私协议*/
    onOpenPrivacy = () => {
        this.setState({
            showPrivacy: true,
        });
    };

    /**关闭隐私协议*/
    onClosePrivacy = () => {
        this.setState({
            showPrivacy: false,
        });
    };

    render() {
        const { showService, showPrivacy } = this.state;
        return (
            <div className="third-page">
                <div className="bottom-line">
                    <div>竞技世界（北京）网络技术有限公司</div>
                    <div className="divider-line">|</div>
                    <div onClick={this.onOpenPrivacy}>隐私政策</div>
                    <div className="divider-line">|</div>
                    <div onClick={this.onOpenService}>服务协议</div>
                </div>
                <div>京公网安备11010802025184号 京ICP证080116号 京ICP备09016390-2号</div>
                <div>京网文[2021]2990-807号 新广出审[2016]1483号</div>
                <div>copyright2007-2024 | TEL 010-82342800</div>
                {showService ? <ServiceModal onClose={this.onCloseService} /> : null}
                {showPrivacy ? <PrivacyModal onClose={this.onClosePrivacy} /> : null}
            </div>
        );
    }
}

export default ThirdPage;
